<template>
  <ul class="event-list">
    <li v-for="event in futureEvents">
      <MyEvent :event="event"></MyEvent>
    </li>
  </ul>
</template>

<script>
import MyEvent from "./MyEvent";
import { mapGetters } from "vuex";

export default {
  components: { MyEvent },
  computed: {
    ...mapGetters(["futureEvents"])
  }
};
</script>

<style>
.event-list {
  list-style-type: none;
  padding: 0;
}
</style>
